import { render, staticRenderFns } from "./buttonSc.vue?vue&type=template&id=171e377a&class=buttonScComponent"
import script from "./buttonSc.ts?vue&type=script&lang=js&external"
export * from "./buttonSc.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('171e377a')) {
      api.createRecord('171e377a', component.options)
    } else {
      api.reload('171e377a', component.options)
    }
    module.hot.accept("./buttonSc.vue?vue&type=template&id=171e377a&class=buttonScComponent", function () {
      api.rerender('171e377a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/form/buttonSc.vue"
export default component.exports